import SuspenseLoader from 'component/base/Loading/SuspenseLoader';
import AuthLayout from 'component/layout/AuthLayout';
import GlobalStyle from 'component/layout/globalStyles';
import Route from 'component/root/LazyRoute';
import React, { lazy, memo } from 'react';
import { useRouteMatch } from 'react-router';
import { Switch } from 'react-router-dom';

import * as paths from './paths';

const LoginView = lazy(() => import('component/view/LoginView'));

const OAuthLoginView = lazy(
  () => import('component/view/OAuthView/OAuthLoginView'),
);

const ForgotPasswordView = lazy(
  () => import('component/view/ForgotPasswordView'),
);

const ResetPasswordViewEmailFunnel = lazy(
  () =>
    import('component/view/ForgotPasswordView/ResetPasswordViewEmailFunnel'),
);

const ForgotPasswordSentView = lazy(
  () => import('component/view/ForgotPasswordSentView'),
);
const ResetPasswordDoneView = lazy(
  () => import('component/view/ResetPasswordDoneView'),
);
const ResetPasswordView = lazy(
  () => import('component/view/ResetPasswordView'),
);
const GetStartedView = lazy(() => import('component/view/GetStartedView'));

const GetStartedSentView = lazy(
  () => import('component/view/GetStartedSentView'),
);

const LazyLoginView = () => (
  <SuspenseLoader publicPath={paths.LOGIN} filePath="component/view/LoginView">
    <LoginView />
  </SuspenseLoader>
);

const LazyOAuthLoginView = () => (
  <SuspenseLoader
    publicPath={paths.OAUTH}
    filePath="component/view/OAuthView/OAuthLoginView"
  >
    <OAuthLoginView />
  </SuspenseLoader>
);

const LazyForgotPasswordView = () => (
  <SuspenseLoader
    publicPath={paths.FORGOT_PASSWORD}
    filePath="component/view/ForgotPasswordView"
  >
    <ForgotPasswordView />
  </SuspenseLoader>
);

const LazyResetPasswordViewEmailFunnel = () => (
  <SuspenseLoader
    publicPath={paths.RESET_PASSWORD_EMAIL_FUNNEL}
    filePath="component/view/ForgotPasswordView/ResetPasswordViewEmailFunnel"
  >
    <ResetPasswordViewEmailFunnel />
  </SuspenseLoader>
);

const LazyForgotPasswordSentView = () => (
  <SuspenseLoader
    publicPath={paths.FORGOT_PASSWORD_SENT}
    filePath="component/view/ForgotPasswordSentView"
  >
    <ForgotPasswordSentView />
  </SuspenseLoader>
);

const LazyResetPasswordDoneView = () => (
  <SuspenseLoader
    publicPath={paths.RESET_PASSWORD_DONE}
    filePath="component/view/ResetPasswordDoneView"
  >
    <ResetPasswordDoneView />
  </SuspenseLoader>
);
const LazyResetPasswordView = () => (
  <SuspenseLoader
    publicPath={paths.RESET_PASSWORD}
    filePath="component/view/ResetPasswordView"
  >
    <ResetPasswordView />
  </SuspenseLoader>
);
const LazyGetStartedView = () => (
  <SuspenseLoader
    publicPath={paths.GET_STARTED}
    filePath="component/view/GetStartedView"
  >
    <GetStartedView />
  </SuspenseLoader>
);
const LazyGetStartedSentView = () => (
  <SuspenseLoader
    publicPath={paths.GET_STARTED_SENT}
    filePath="component/view/GetStartedSentView"
  >
    <GetStartedSentView />
  </SuspenseLoader>
);

const hideActivateInviteCodeLinkPaths = [paths.RESET_PASSWORD_EMAIL_FUNNEL];
/**
 * Group of components that share the same narrow dashboard
 * layout without a nav panel.
 */
const AuthLayoutPage = (): JSX.Element => {
  const showActivateInviteCodeLink = !useRouteMatch(
    hideActivateInviteCodeLinkPaths,
  );
  return (
    <>
      <GlobalStyle />
      <AuthLayout
        showActivateInviteCodeLink={showActivateInviteCodeLink}
        showSignUpButton={showActivateInviteCodeLink}
      >
        <Switch>
          <Route anonymous exact path={paths.LOGIN}>
            <LazyLoginView />
          </Route>
          <Route anonymous exact path={paths.OAUTH}>
            <LazyOAuthLoginView />
          </Route>
          <Route anonymous exact path={paths.RESET_PASSWORD_EMAIL_FUNNEL}>
            <LazyResetPasswordViewEmailFunnel />
          </Route>
          <Route anonymous exact path={paths.FORGOT_PASSWORD}>
            <LazyForgotPasswordView />
          </Route>
          <Route anonymous exact path={paths.FORGOT_PASSWORD_SENT}>
            <LazyForgotPasswordSentView />
          </Route>
          <Route anonymous exact path={paths.RESET_PASSWORD_DONE}>
            <LazyResetPasswordDoneView />
          </Route>
          <Route anonymous exact path={paths.RESET_PASSWORD}>
            <LazyResetPasswordView />
          </Route>
          <Route anonymous exact path={paths.GET_STARTED}>
            <LazyGetStartedView />
          </Route>
          <Route anonymous exact path={paths.GET_STARTED_SENT}>
            <LazyGetStartedSentView />
          </Route>
        </Switch>
      </AuthLayout>
      <GlobalStyle />
    </>
  );
};

/*
  Memoisation here prevents re-rendering of layout components
  on change of nested routes.
*/
export default memo(AuthLayoutPage);

/*


*/
